import { ModuleFE_SmartOnFHIR } from "./ModuleFE_SmartOnFHIR.js";
export * from './ModuleFE_SmartOnFHIR.js';
export const ModulePackFE_Advisor_FHIR = [
    ModuleFE_SmartOnFHIR,
];
//# sourceMappingURL=index.js.map